import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CancellationReasonType } from './parcel';

export interface CancellationReasonItem {
  id: string;
  reasonId: CancellationReasonType;
  label: string;
}

/**
 * Причины отмены, доступные оператору СЦ. Один список и для одиночной отмены
 * (CancelParcel), и для массовой (BulkCancelParcels) — чтобы наборы не расходились.
 */
export function useCancellationReasons(): CancellationReasonItem[] {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        id: '8',
        reasonId: CancellationReasonType.SellerRejection,
        label: t('sellerRejection'),
      },
      {
        id: '9',
        reasonId: CancellationReasonType.Oversized,
        label: t('oversized'),
      },
      {
        id: '23',
        reasonId: CancellationReasonType.OverWeight,
        label: t('overweight'),
      },
      {
        id: '29',
        reasonId: CancellationReasonType.HazardMaterials,
        label: t('hazardMaterials'),
      },
      {
        id: '41',
        reasonId: CancellationReasonType.DangerousGoods,
        label: t('dangerousGoods'),
      },
    ],
    [t],
  );
}
